import { action } from 'satcheljs';
/**
 * Action to initialize the calendar processing options in store
 */
var initializeCalendarProcessingOptions = action('initializeCalendarProcessingOptions', function (calendarProcessingOptions) { return ({
    calendarProcessingOptions: calendarProcessingOptions,
}); });
export default initializeCalendarProcessingOptions;
//# sourceMappingURL=initializeCalendarProcessingOptions.js.map